<template>
  <div class="page fellowship">


    <div class="uk-section uk-section-default uk-background-legible uk-background-cover uk-background-top-center uk-background-fixed uk-background-blend-multiply uk-padding-large hero" v-bind:style="{ backgroundImage: `url(${page.heroImage.large4x3})`}" v-if="!!page.heroImage && page.heroImage.id > 0">
        <div class="uk-grid uk-margin-xlarge-top" uk-grid>
            <div class="uk-light uk-width-1-2@l uk-width-3-5@m uk-width-1-1@xs uk-margin-xlarge-bottom">

                <router-link :to="parent.link" v-if="parent"><label>{{parent.menuTitle}}</label></router-link>
                <h1 class="uk-margin-small-top">{{page.title}}</h1>

                <slot name="summary">
                    <p class="uk-text-lead" v-if="page.summary">{{page.summary}}</p>
                </slot>

                <slot name="subheader"></slot>

          </div>
        </div>
    </div>
    <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header" v-else>
      <div class="uk-light uk-container uk-container-small uk-text-center">

          <router-link :to="parent.link" v-if="parent">
            <label>{{parent.menuTitle}}</label>
          </router-link>
          <h1 class="uk-margin-small-top">{{page.title}}</h1>

          <slot name="summary">
              <p class="uk-text-lead" v-if="page.summary">{{page.summary}}</p>
          </slot>

          <slot name="subheader"></slot>
      </div>
    </div>



    <CTA :feature="page.topFeature" v-if="page.topFeature && page.topFeature.id > 0" />


    <Testimonials :testimonials="(page && page.testimonialsArray) ? JSON.parse(page.testimonialsArray, true) : false" />


    <div class="uk-section uk-section-medium uk-background-white">
        <div class="uk-container uk-container-small">
            <div class="content" v-html="page.content"></div>

            <div class="subpages" v-if="page.subpages">
                <div v-for="subpage in page.subpages">
                    {{subpage.title}}
                </div>
            </div>

        </div>
    </div>


    <div class="uk-section uk-section-medium uk-background-muted uk-light" v-if="page.secondaryContent">
        <div class="uk-container uk-container-small">
            <div class="content" v-html="page.secondaryContent"></div>
        </div>
    </div>


    <CTA :feature="page.bottomFeature" v-if="page.bottomFeature && page.bottomFeature.id > 0" />

  </div>
</template>

<script>

import CTA from '../components/CTA.vue'

export default {
    props: ['page', 'parent'],
    components: {
        CTA
    }
}
</script>
